import paycoUtils from '@/assets/js/utils'

interface ITicket {
  ticketId: string;
  ticketCount?: number;
  ticketStatus?: string;
  validityEndYmd?: string;
  validityEndYmdt?: string;
  remainedDays?: number;
  refundableYn?: string;

  productName: string;
  productImageUrl: string;

  senderName: string;
}

class Ticket {
  constructor(args: ITicket) {
    return Object.assign(this, args);
  }

  get remainedDayString(): string {
    if (this.remainedDays == 0) {
      return "오늘까지";
    }
    return this.remainedDays + "일 남음";
  }

  get isValidUntilToday(): boolean {
    if (this.remainedDays == 0) {
      return true;
    }
    return false;
  }

  get isRefundableBadgeStatus(): boolean {
    return paycoUtils.convertYnToBoolean(this.refundableYn)
    || this.ticketStatus === "REFUNDING"
    || this.ticketStatus === "REFUNDFAIL";
  }
}

interface Ticket extends ITicket {
}

export default Ticket;